// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "nav[data-v-82ce383e]{display:flex;flex-direction:column;gap:.5rem;margin:1em;max-width:calc(100vw - 2em)}@media screen and (min-width:64.063em){nav[data-v-82ce383e]{flex-direction:row;gap:1rem;justify-content:center;margin:2em}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
